module.exports = __webpack_public_path__ + "static/media/ES-Umh.870f0fc9.png";